"use client"

import { Card, CardContent, cn } from '@yeshuman/sdk'
import { useId, useState } from 'react'
import { ChevronDown } from 'lucide-react'


export type EvaluationSummarySectionProps = {
  summary: string
  defaultOpen?: boolean
}

export function EvaluationSummarySection({
  summary,
  defaultOpen = true,
}: EvaluationSummarySectionProps) {
  const [open, setOpen] = useState(defaultOpen)
  const contentId = useId()

  return (
    <Card className="gap-0 overflow-hidden p-0">
      <button
        type="button"
        className="flex w-full items-center justify-between gap-3 px-[var(--sp-card)] py-3 text-left focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring rounded-xl"
        aria-expanded={open}
        aria-controls={contentId}
        onClick={() => setOpen((value) => !value)}
      >
        <span className="font-semibold text-sm">Analysis Summary</span>
        <ChevronDown
          className={cn(
            'h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200',
            open && 'rotate-180',
          )}
          aria-hidden
        />
      </button>
      {open ? (
        <CardContent
          id={contentId}
          className="border-t px-[var(--sp-card)] pb-[var(--sp-card)] pt-3"
        >
          <p className="text-muted-foreground text-sm">{summary}</p>
        </CardContent>
      ) : null}
    </Card>
  )
}
